module.exports = __webpack_public_path__ + "static/media/WheatStage105.2c3533a3.PNG";